import { defineStore } from 'pinia'
import { ref, reactive, watch } from 'vue'
import { router } from '@/router'

interface optionItem {
  flowId?: string // 流程配置Id
  processId?: string // 数据对应流程Id
  processGuid?: string
  type: 'approve' | 'business' // 流程类型 approve 审批流程 business 业务流程
}

export const useGlobalFlow = defineStore('useGlobalFlow', () => {
  const flowVisible = ref(false)
  const flowBusinessVisible = ref(false)

  const flowOption = reactive({
    flowId: '',
    processId: '',
    processGuid: '',
    type: 'approve'
  })

  const updateTime = ref(0)

  function init(option: optionItem) {
    flowVisible.value = false
    flowBusinessVisible.value = false
    flowOption.flowId = option.flowId || ''
    flowOption.processId = option.processId || ''
    flowOption.processGuid = option.processGuid || ''
    flowOption.type = option.type
    setTimeout(() => {
      setVisible(true, flowOption.type)
    }, 100)
  }

  function setVisible(bool: boolean, type: string) {
    if (type === 'approve') {
      flowVisible.value = bool
    } else {
      flowBusinessVisible.value = bool
    }
  }

  function setUpdateTime(time: number | undefined = undefined) {
    updateTime.value = time || new Date().getTime()
  }

  watch(
    () => router.currentRoute,
    val => {
      if (unref(val)?.path === '/login') {
        setVisible(false, 'approve')
        setVisible(false, 'business')
      }
    },
    { deep: true }
  )

  return {
    flowOption,
    flowVisible,
    updateTime,
    init,
    setVisible,
    flowBusinessVisible,
    setUpdateTime
  }
})
